import React, { useRef, useCallback } from "react";
import { Trans } from "react-i18next";
import SignatureCanvas from "react-signature-canvas";
import { Box, Button } from "@chakra-ui/react";
const SignatureInput = ({ onChange, value }) => {
  const sigCanvas = useRef({});
  const sigPad = useRef({});

  const measuredRef = useCallback((node) => {
    const resizeCanvas = (signaturePad, canvas) => {
      canvas.width = canvas.parentElement.clientWidth; // width of the .canvasWrapper
      canvas.height = canvas.parentElement.clientHeight; // widthRatio

      signaturePad.clear();
    };

    if (node !== null) {
      sigCanvas.current = node.getCanvas();
      sigPad.current = node.getSignaturePad();
      resizeCanvas(node.getSignaturePad(), node.getCanvas());
    }
  }, []);

  const onEnd = () => {
    onChange(sigPad.current.toDataURL("image/png"));
  };

  const clearInput = () => {
    sigPad.current.clear();
    onChange(null);
  };

  return (
    <Box
      position={"relative"}
      display={"inline-block"}
      width={"full"}
      minH={"240px"}
    >
      <Box
        position={"absolute"}
        bottom={0}
        width={"full"}
        borderTop={"1px dotted"}
        borderColor={"blackAlpha.700"}
        textAlign={"center"}
        pointerEvents={"none"}
        color={"blackAlpha.600"}
      >
        <Trans i18nKey={"please_sign"}>Please sign your name above</Trans>
      </Box>
      {value && (
        <Box
          display={"inline"}
          position={"absolute"}
          top={"20px"}
          right={"20px"}
        >
          <Button
            onClick={clearInput}
            size={"sm"}
            data-testid={"clear-signature"}
          >
            Clear
          </Button>
        </Box>
      )}

      <SignatureCanvas ref={measuredRef} onEnd={onEnd} penColor="black" />
    </Box>
  );
};

export default SignatureInput;
